import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["type", "code", "message"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GENDER } from "@/lib/constants";
import dayjs from "@/lib/day";
import { AUTH_ERROR_MESSAGES, MY_SKP_LOGIN_REASONS, MY_SKP_RELATION_MESSAGES } from "@/lib/errors";
import { myskpSignupComplete } from "@/lib/mailTemplate";
import MySkpToken from "@/lib/myskpToken";
import sendEmail from "@/lib/sendEmail";
import { gql } from "@apollo/client";
import { UserInputError } from "apollo-server-errors";
import { createToken, sleep } from "./helper";
import Uid2Token from "@/lib/uid2Token";
import { birthdayValidate } from "@/lib/birthdayValidate";
export const typeDef = gql`
  type MySkpUserAttrs {
    mailAddress: String
    first_name: String
    last_name: String
    birthday: String
    sex: String
  }

  type MySkpAuthError {
    type: String
    code: Int
    message: String
    token: String
  }

  type MySkpAuth @cacheControl(maxAge: 0) {
    token: String
    user: AccountUser
    error: MySkpAuthError
  }

  type MySkpTokenVerifyResult @cacheControl(maxAge: 0) {
    result: Boolean
    attrs: MySkpUserAttrs
  }

  type MySkpRelationResult @cacheControl(maxAge: 0) {
    auth: MySkpAuth
    relationResult: Boolean
    hasContinuousProduct: Boolean
  }

  type Query {
    mySkpTokenVerify(token: String!): MySkpTokenVerifyResult
  }

  type Mutation {
    mySkpLogin(
      loginid: String!
      password: String!
      signature: String!
    ): MySkpAuth

    mySkpSignup(
      token: String!
      mailAddress: String!
      password: String!
      firstName: String!
      lastName: String!
      birthday: String!
      sex: String!
      terms: String!
      signature: String!
    ): MySkpRelationResult

    mySkpRelation(
      token: String!
      mailAddress: String!
      password: String!
      signature: String!
    ): MySkpRelationResult

    mySkpRelationAuth(
      mailAddress: String!
      password: String!
    ): MySkpRelationResult
  }
`;
export const resolvers = {
  Query: {
    mySkpTokenVerify: async (_parent, _ref, _ref2) => {
      let {
        token
      } = _ref;
      let {
        req,
        res
      } = _ref2;
      const myskpToken = new MySkpToken(req, res);
      const verified = await myskpToken.verify(token);
      if (verified) {
        return {
          result: true,
          attrs: verified
        };
      } else {
        return {
          result: false
        };
      }
    }
  },
  Mutation: {
    mySkpLogin: async (_parent, _ref3, _ref4) => {
      let {
        loginid,
        password,
        signature
      } = _ref3;
      let {
        req,
        res,
        dataSources
      } = _ref4;
      try {
        const user = await dataSources.myskp.login(loginid, password);
        if (user.error) {
          const _user$error = user.error,
            {
              type,
              code,
              message
            } = _user$error,
            attrs = _objectWithoutProperties(_user$error, _excluded);
          const errorResponse = {
            error: {
              type,
              code,
              message
            }
          };
          if (["need_user_regist", "need_relation"].includes(MY_SKP_LOGIN_REASONS[code])) {
            // alice_bs_numbersはフロントに返却しないようにする
            // サーバー側で保管し、OTPを発行する
            const myskpToken = new MySkpToken(req, res);
            const token = myskpToken.publish(_objectSpread({
              mailAddress: loginid
            }, attrs));
            errorResponse.error.token = token;
          }
          return errorResponse;
        } else {
          const token = await createToken(req, res, user, signature, false);
          const uid2 = new Uid2Token(req, res);
          await uid2.getToken();
          return {
            token,
            user: user.user
          };
        }
      } catch (e) {
        var _e$extensions, _response$error, _response$error2;
        console.log("myskp login auth error", e);
        // console.log(JSON.stringify(e.extentions, null, 2));
        const response = e === null || e === void 0 || (_e$extensions = e.extensions) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.response) === null || _e$extensions === void 0 ? void 0 : _e$extensions.body;
        if (response && (response === null || response === void 0 || (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.code) == 10006) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["acountlock"]);
        } else if (response && (response === null || response === void 0 || (_response$error2 = response.error) === null || _response$error2 === void 0 ? void 0 : _response$error2.code) == 11005) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["myskpSimilarAccount"]);
        } else {
          throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);
        }
      }
    },
    mySkpSignup: async (_parent, args, _ref5) => {
      let {
        req,
        res,
        dataSources
      } = _ref5;
      try {
        // alice_bs_numbersを取り出す
        const myskpToken = new MySkpToken(req, res);
        const verified = await myskpToken.verify(args.token);
        if (!verified) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["default"], {
            invalidArgs: Object.keys(args)
          });
        }
        // 生年月日をバリデート
        if (!birthdayValidate(args === null || args === void 0 ? void 0 : args.birthday)) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);
        }
        // ユーザーがすでに存在しているか
        const existsUser = await dataSources.user.existed(args.mailAddress);
        if (existsUser) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);
        }
        // alice_bs_numbersをいれて会員登録
        const user = await dataSources.user.signup(args, {
          alice_bs_numbers: verified.alice_bs_numbers
        });
        const token = await createToken(req, res, user, args.signature, false);
        await sleep(200);
        // Myスカパー連携APIをコールする
        const relationResult = await dataSources.myskp.relation();
        // 規約同意
        const agreeTerms = args.terms.split(",");
        await Promise.all(agreeTerms.map(async key => {
          return await dataSources.terms.agree(key);
        }));
        await sendEmail(myskpSignupComplete({
          address: args.mailAddress,
          user: user.user
        }));
        const uid2 = new Uid2Token(req, res);
        await uid2.getToken();
        return {
          auth: {
            token,
            user: user.user
          },
          relationResult: relationResult.result,
          hasContinuousProduct: relationResult.my_transition_right_flag
        };
      } catch (e) {
        var _e$extensions2, _e$extensions3;
        console.log("myskp signup error", e);
        const status = e === null || e === void 0 || (_e$extensions2 = e.extensions) === null || _e$extensions2 === void 0 || (_e$extensions2 = _e$extensions2.response) === null || _e$extensions2 === void 0 ? void 0 : _e$extensions2.status;
        const body = e === null || e === void 0 || (_e$extensions3 = e.extensions) === null || _e$extensions3 === void 0 || (_e$extensions3 = _e$extensions3.response) === null || _e$extensions3 === void 0 ? void 0 : _e$extensions3.body;
        if (status && body) {
          var _body$error;
          // status 422 code 10003のエラーはアカウントのユニーク制約に引っかかったもの
          // 個別にエラーを出すかどうか、安易にエラーをだすとメールアドレスが登録されているかわかってしまう
          // error code 70000台はAlice関連のエラー
          console.log(status, body);
          if (status == 500 && (body === null || body === void 0 || (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code) > 70000) {
            console.log("alice error", status, body);
          }
        }
        throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);
      }
    },
    mySkpRelation: async (_parent, args, _ref6) => {
      let {
        req,
        res,
        dataSources
      } = _ref6;
      try {
        // alice_bs_numbersを取り出す
        const myskpToken = new MySkpToken(req, res);
        const verified = await myskpToken.verify(args.token);
        if (!verified) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["default"], {
            invalidArgs: Object.keys(args)
          });
        }
        // ログインする
        const user = await dataSources.user.login(args.mailAddress, args.password);
        const token = await createToken(req, res, user, args.signature, false);
        await sleep(200);
        // alice_bs_numbersを更新
        await dataSources.user.updateValues({
          alice_bs_numbers: verified.alice_bs_numbers
        });
        // Myスカパー連携APIをコールする
        const relationResult = await dataSources.myskp.relation();
        return {
          auth: {
            token,
            user: user.user
          },
          relationResult: relationResult.result,
          hasContinuousProduct: relationResult.my_transition_right_flag
        };
      } catch (e) {
        var _e$extensions4, _response$error3;
        console.log("login auth error", e);
        // console.log(JSON.stringify(e.extentions, null, 2));
        const response = e === null || e === void 0 || (_e$extensions4 = e.extensions) === null || _e$extensions4 === void 0 || (_e$extensions4 = _e$extensions4.response) === null || _e$extensions4 === void 0 ? void 0 : _e$extensions4.body;
        if (response && (response === null || response === void 0 || (_response$error3 = response.error) === null || _response$error3 === void 0 ? void 0 : _response$error3.code) == 10006) {
          throw new UserInputError(AUTH_ERROR_MESSAGES["acountlock"]);
        } else {
          throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);
        }
      }
    },
    // MyスカパーのIDパスワードで認証して連携する
    mySkpRelationAuth: async (_parent, _ref7, _ref8) => {
      let {
        mailAddress,
        password
      } = _ref7;
      let {
        req,
        dataSources
      } = _ref8;
      try {
        const relationResult = await dataSources.myskp.authRelation(mailAddress, password);
        sleep(200);
        const res = await dataSources.user.me();
        return {
          auth: {
            token: req.userToken.accessToken,
            user: res.user
          },
          relationResult: relationResult.result,
          hasContinuousProduct: relationResult.my_transition_right_flag
        };
      } catch (e) {
        var _e$extensions5, _response$error4;
        console.log("myskp auth relation error", e);
        const response = e === null || e === void 0 || (_e$extensions5 = e.extensions) === null || _e$extensions5 === void 0 || (_e$extensions5 = _e$extensions5.response) === null || _e$extensions5 === void 0 ? void 0 : _e$extensions5.body;
        const code = response === null || response === void 0 || (_response$error4 = response.error) === null || _response$error4 === void 0 ? void 0 : _response$error4.code;
        if ([10001, 10002, 10003].includes(response && code)) {
          throw new UserInputError(MY_SKP_RELATION_MESSAGES[code]);
        } else {
          throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);
        }
      }
    }
  },
  MySkpUserAttrs: {
    sex: attrs => {
      return Object.keys(GENDER).find(v => GENDER[v] === attrs.sex) || "unknown";
    },
    birthday: attrs => {
      const birthday = dayjs(attrs.birthday);
      if (attrs.birthday && attrs.birthday.length > 0 && birthday.isValid()) {
        return birthday.format("YYYY-MM-DD");
      } else {
        return null;
      }
    }
  }
};